import {
  CREATE_TEACHER_INSTITUTION_URL,
  DELETE_TEACHER_INSTITUTION_URL,
  GET_ALL_TEACHER_INSTITUTION_URL,
  UPDATE_TEACHER_INSTITUTION_URL,
  RESET_TEACHER_INSTITUTION_PASSWORD_URL,
} from "../../apiurls/apiurls";

export const getInstitutionTeacher = async (token, params = {}) => {
  const query = new URLSearchParams({});
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_ALL_TEACHER_INSTITUTION_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createTeacherInstitution = async (token, payload) => {
  const url = `${CREATE_TEACHER_INSTITUTION_URL}`;
  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateTeacherInstitution = async (token, payload, id) => {
  const url = `${UPDATE_TEACHER_INSTITUTION_URL}?id=${id}`;
  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteTeacherInstitution = async (token, id) => {
  const url = `${DELETE_TEACHER_INSTITUTION_URL}?id=${id}`;
  try {
    const response = await fetch(`${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const resetTeacherInstitutionPassword = async (token, payload, id) => {
  const url = `${RESET_TEACHER_INSTITUTION_PASSWORD_URL}?id=${id}`;
  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error resetting teacher password:", error);
    throw error;
  }
};
